import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsMoneyBody,
  PostApplicationsMoneyResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsMoney = createAsyncThunk<
  PostApplicationsMoneyResponse,
  PostApplicationsMoneyBody
>("applications/postApplicationsMoney", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsMoney(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications money", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications money", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});